module.exports = __webpack_public_path__ + "static/media/CarouselBlankMedcare_Old.9dbb8948.jpg";